var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "88", height: "85", viewBox: "0 0 88 85", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.666 56.667l16.816-16.242a7.467 7.467 0 0 1 5.184-2.074c1.945 0 3.81.746 5.185 2.074l16.816 16.242m-7.334-7.084l5.816-5.617a7.467 7.467 0 0 1 5.184-2.074c1.945 0 3.81.746 5.185 2.074l5.815 5.617m-22-21.25h.037M22 70.833h44c1.945 0 3.81-.746 5.185-2.074a6.963 6.963 0 0 0 2.148-5.009v-42.5c0-1.878-.772-3.68-2.148-5.009A7.467 7.467 0 0 0 66 14.167H22c-1.945 0-3.81.746-5.186 2.074a6.963 6.963 0 0 0-2.148 5.01v42.5c0 1.878.773 3.68 2.148 5.008A7.467 7.467 0 0 0 22 70.833z", stroke: "#DADADA", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});